/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from "@cian/http-api/shared/model";

export type TCheckPaymentModel = IModel<
  ICheckPaymentRequest,
  TCheckPaymentResponse
>;

export interface ICheckPaymentRequest {
  paymentId?: string | null;
}

export type TCheckPaymentResponse =
  | ICheckPaymentResponse200
  | ICheckPaymentResponse400;

export interface ICheckPaymentResponse200
  extends IModelResponse<ICheckPaymentResponse> {
  statusCode: 200;
}

export interface ICheckPaymentResponse400
  extends IModelResponse<ICheckPaymentResponseError> {
  statusCode: 400;
}

export interface ICheckPaymentResponse {
  /** Статус платежа **/
  status?: EStatus | null;
}

export interface ICheckPaymentResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICheckPaymentResponse | ICheckPaymentResponseError;

export enum EStatus {
  /** Платёж прошёл успешно **/
  Succeeded = "succeeded",
  /** Статус платежа пока не определён **/
  Pending = "pending",
  /** Платёж отменён **/
  Canceled = "canceled"
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICheckPaymentResponse): TResponse200;
  400(response: ICheckPaymentResponseError): TResponse400;
}
